module.exports = "/_next/static/images/e47cd88cc3f92669197ac950f599f5c4-cartao-proximo-ao-olho-lg@3x.jpg";